module.exports = __webpack_public_path__ + "img/fire.82b218a2.svg";